import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Trophy, User } from "lucide-react";
import LogoutButton from "@/components/profile/LogoutButton";
import { AffiliateSidebarCTA } from "@/components/navigation/AffiliateSidebarCTA";

const navItems = [
  { href: "/campaigns", label: "Campaigns", icon: Trophy },
  { href: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { href: "/profile", label: "Profile", icon: User },
];

export function Sidebar() {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <aside className="hidden lg:flex lg:w-64 lg:flex-col lg:border-r lg:border-white/10 lg:bg-zinc-900/50 lg:sticky lg:top-0 lg:h-screen lg:overflow-hidden">
      <div className="p-6">
        <h1 className="text-xl font-bold text-lime-300">LTS Affiliate</h1>
        <p className="mt-1 text-xs text-white/60">Creator Console</p>
      </div>
      
      <nav className="flex-1 space-y-1 px-3">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = pathname === item.href;
          
          return (
            <Link
              key={item.href}
              to={item.href}
              className={`flex items-center gap-3 rounded-2xl px-4 py-3 text-sm font-medium transition-colors ${
                isActive
                  ? "bg-lime-500/20 text-lime-300"
                  : "text-white/70 hover:bg-white/5 hover:text-white"
              }`}
            >
              <Icon className="h-5 w-5" />
              {item.label}
            </Link>
          );
        })}
      </nav>
      
      <div className="border-t border-white/10 p-4 flex flex-col space-y-4">
        <AffiliateSidebarCTA />
        
        <div>
          <p className="text-xs text-white/40">© 2025 LTS Affiliate Program</p>
        </div>
        
        <div className="mt-auto">
          {/* Sidebar sign-out visible on desktop (hidden on small screens where logout lives in Profile) */}
          <div className="hidden lg:block">
            <LogoutButton />
          </div>
        </div>
      </div>
    </aside>
  );
}
